'use client';

import {useRef} from 'react';

import {AppsSelection} from '@web-catalog/types';

import {Scroller} from '@web-catalog/ui-kit/Scroller';

import {
  useLogCompilationSwipe,
  useLogOnCompilationShow,
} from '@web-catalog/utils/analytics/interestingPage';
import {
  getFeaturingAnalyticsType,
  useFeaturingAnalytics,
} from '@web-catalog/utils/analytics/useFeaturingAnalytics';

import {AppWithScreenshotsCard} from './AppWithScreenshotsCard';
import styles from './SelectionWithScreenshots.module.scss';

type Props = {
  selection: AppsSelection | null;
  displayedSelectionNumber: number;
};

export const SelectionWithScreenshots = ({
  selection,
  displayedSelectionNumber,
}: Props) => {
  const ref = useRef(null);
  useLogOnCompilationShow({
    ref,
    selection,
    selectionNumber: displayedSelectionNumber,
  });
  const {logAppSelect} = useFeaturingAnalytics();
  const onSwipe = useLogCompilationSwipe(selection, displayedSelectionNumber);
  if (!selection) {
    return null;
  }
  const apps = selection.content.flatMap((item) =>
    item.type === 'APPS' ? item.appInfo : [],
  );
  if (!apps.length) {
    return null;
  }
  return (
    <section ref={ref} data-testid="selection_with_app_cards">
      <h2>{selection.title?.value}</h2>
      <Scroller onSwipe={onSwipe}>
        {apps.map((app, index) => (
          <AppWithScreenshotsCard
            key={app.packageName}
            app={app}
            className={styles.card}
            onClick={() =>
              logAppSelect(
                app,
                index + 1,
                selection.id,
                selection.title?.value,
                getFeaturingAnalyticsType(
                  selection.type,
                  selection.displayType,
                ),
              )
            }
          />
        ))}
      </Scroller>
    </section>
  );
};
